import { EventsColumnSkeleton } from './EventsColumnSkeleton';

interface TogglableEventColumnSkeletonProps {
  className?: string;
}

export function TogglableEventColumnSkeleton({
  className = '',
}: TogglableEventColumnSkeletonProps) {
  return (
    <div className={`h-full flex flex-col ${className}`}>
      {/* In Progress Section - Default expanded */}
      <div className="flex-1">
        <EventsColumnSkeleton
          title="In Progress"
          cardCount={3}
          showToggle={true}
        />
      </div>

      {/* Closed Section - Default collapsed */}
      <div className="flex-shrink-0">
        <EventsColumnSkeleton title="Closed" cardCount={1} showToggle={true} />
      </div>
    </div>
  );
}
